import React from 'react';
import { useIsXSmallResolution } from '../../../../hooks/use-is-xsmall-resolution.js';
import { Button } from '../../../button/button.js';
import { InlineImage } from '../../../inline-image/inline-image.js';
function HeadingActionButton(props) {
    const { action, buttonClassName, inlineImageClassName, onClick, onContextMenuClick, onDoubleClick } = props;
    const { buttonTheme, icon } = action;
    const isXSmallResolution = useIsXSmallResolution();
    if (isXSmallResolution) {
        if (!icon) {
            return null;
        }
        return (React.createElement(InlineImage, { className: inlineImageClassName, onClick: onClick, src: icon }));
    }
    return (React.createElement(Button, { className: buttonClassName, icon: icon, onClick: onClick, onContextMenuClick: onContextMenuClick, onDoubleClick: onDoubleClick, theme: buttonTheme, value: "" }));
}
export { HeadingActionButton, };
//# sourceMappingURL=heading-action-button.js.map